import React from 'react';

import styles from './SectionTextView.module.scss';

type SectionTextViewProps = {
  title: string;
  text: string;
};

export const SectionTextView: React.FC<SectionTextViewProps> = ({ title, text }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{title}</p>
      <p className={styles.content}>{text}</p>
    </div>
  );
};
